import { EdgeStack } from '@/react/edge/edge-stacks/types';

import { GitForm } from './GitForm';
import { HelmRepositoryEditForm } from './HelmRepositoryEditForm';
import { NonGitStackForm } from './NonGitStackForm';

export function EditEdgeStackForm({ edgeStack }: { edgeStack: EdgeStack }) {
  if (edgeStack.GitConfig) {
    return <GitForm stack={edgeStack} />;
  }

  if (edgeStack.HelmConfig?.ChartURL) {
    return <HelmRepositoryEditForm edgeStack={edgeStack} />;
  }

  return <NonGitStackForm edgeStack={edgeStack} />;
}
